<div class="heading">
    <p>Change Role</p>
</div>
<div class="container" style="margin-bottom: 20px;">
    <p class="m-0" style="color: #454554;"><span style="color: #000000; font-weight: 700;">Note:</span> When selecting multiple users in bulk, the previously assigned roles and categories will be replaced with the newly selected role and category, which will be considered final.</p>
</div>
<div class="container mb-20">
    <label for="role" style="color: #5E5E72; font-size: 14px; font-weight: 700; display: inline-block;"
        class="mb-4">Role <span class="required">*</span></label>
    <div class="select-container">
        <select id="role" class="dropdown w-100" [(ngModel)]="selectedRole" (change)="roleItemChange($event)" required #roleRef="ngModel">
            <option value="" disabled selected>Select role</option>
            <option *ngFor="let role of rolesList" [value]="role.role_name">{{role?.role_name?.charAt(0)?.toUpperCase() + role?.role_name?.slice(1)}}</option>
        </select>
        <div *ngIf="formSubmitted && roleRef.invalid" style="color: red;">Please Select a role</div>
    </div>
</div>

<div class="container mb-20" *ngIf="selectedRole === 'curator'">
    <label for="category" style="color: #5E5E72; font-size: 14px; font-weight: 700; display: inline-block;"
        class="mb-4">Choose Curator category <span class="required">*</span></label>
    <div class="select-container" style="width: 93%;">
        <ng-multiselect-dropdown [settings]="dropdownSettings" [data]="categoryDropdownList"
            [(ngModel)]="selectedCategoryItems" (ngModelChange)="onCategoryItemSelect($event)" name="category">
        </ng-multiselect-dropdown>
        <div *ngIf="!selectedCategoryItems.length && isCatvalid" style="color: red;">Please Select category</div>
    </div>
</div>

<div class="btn-container">
    <app-button [type]="'secondary'" [buttonType]="'button'" [buttonText]="'Cancel'"
        [iconSrc]="''" class="mr-12" (click)="close()"></app-button>
    <app-button [type]="'primary'" [buttonType]="'button'" [buttonText]="'Submit'"
        [iconSrc]="''" (click)="submit()"></app-button>
</div>